import { Container, Section } from '@resolute/ui';
import { Calculator, PiggyBank, Receipt, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';


import { Reveal, StaggerGroup, StaggerItem } from '@/components/motion/reveal';
import { Seo } from '@/lib/seo';

const TOOLS = [
  {
    to: '/calculators/emi',
    icon: Calculator,
    title: 'EMI Calculator',
    body: 'Estimate your monthly home-loan instalment, total interest and payment breakdown.',
  },
  {
    to: '/calculators/affordability',
    icon: PiggyBank,
    title: 'Affordability Calculator',
    body: 'See how much home you can realistically afford from your income and savings.',
  },
  {
    to: '/calculators/rental-yield',
    icon: TrendingUp,
    title: 'Rental Yield & ROI',
    body: 'Model gross/net yield, cap rate and multi-year total return for investment property.',
  },
  {
    to: '/calculators/stamp-duty',
    icon: Receipt,
    title: 'Stamp Duty Calculator',
    body: 'Estimate stamp duty and registration cost on a property purchase.',
  },
];

export default function ToolsHubPage() {
  return (
    <Section>
      <Seo
        title="Property Tools & Calculators"
        description="Free calculators for home buyers and investors — EMI, affordability, rental yield and ROI. Plan your purchase with Resolute Property Solutions."
        path="/calculators"
      />
      <Container className="max-w-5xl">
        <Reveal>
          <header className="mb-10">
            <h1 className="font-display text-3xl font-semibold tracking-tight sm:text-4xl">
              Tools &amp; calculators
            </h1>
            <p className="mt-2 max-w-2xl text-muted-foreground">
              Make confident decisions with calculators built for the Indian market — from your
              first EMI to multi-year investment returns.
            </p>
          </header>
        </Reveal>

        <StaggerGroup className="grid gap-5 sm:grid-cols-2">
          {TOOLS.map(({ to, icon: Icon, title, body }) => (
            <StaggerItem key={to}>
              <Link
                to={to}
                className="group flex flex-col gap-3 rounded-xl border border-border bg-card p-6 transition-colors duration-fast ease-out-expo hover:border-primary/50"
              >
                <span className="flex size-11 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <Icon className="size-5" aria-hidden="true" />
                </span>
                <h2 className="text-lg font-semibold transition-colors duration-fast ease-out-expo group-hover:text-primary">
                  {title}
                </h2>
                <p className="text-sm text-muted-foreground">{body}</p>
              </Link>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </Container>
    </Section>
  );
}
